import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { __API_URL__ } from "../../SERVER_URL";
import axios from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useEcrfContext } from "../../context/EcrfContext";

const AddTrialTypePopUp = ({
  showTrialTypeModal,
  setShowTrialTypeModal,
  blockId,
  trialTypeIds,
  setTrialTypeIds,
}) => {
  const token = localStorage.getItem("token");
  const queryClient = useQueryClient();

  const { trialTypes } = useEcrfContext();

  const updateTrialTypes = () => {
    const data = {
      block_id: blockId,
      trial_type_id_list: trialTypeIds,
    };
    axios
      .post(`${__API_URL__}/api/ecrf/update_trial_type/`, data, {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        toast.success(response.data.message);
        queryClient.invalidateQueries({ queryKey: ["visits"] });
        setShowTrialTypeModal(false);
        setTrialTypeIds([]);
      })
      .catch(() => {
        toast.error();
      });
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setTrialTypeIds(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <Dialog
      open={showTrialTypeModal}
      onClose={() => {
        setShowTrialTypeModal(false);
        setTrialTypeIds([]);
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Add Trial Type
        <IconButton
          aria-label="close"
          onClick={() => {
            setShowTrialTypeModal(false);
            setTrialTypeIds([]);
          }}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <InputLabel id="trial-type-select-label">
          {trialTypeIds.length > 1 ? "Trial Types" : "Trial Type"}
        </InputLabel>
        <Select
          labelId="trial-type-select-label"
          multiple
          value={trialTypeIds}
          onChange={handleChange}
          renderValue={(selected) =>
            selected
              .map((id) => {
                const trial = trialTypes?.find((t) => t.id === id);
                return trial ? trial.title : "";
              })
              .join(", ")
          }
          fullWidth
        >
          {trialTypes?.map((type) => (
            <MenuItem key={type.id} value={type.id}>
              <Checkbox checked={trialTypeIds.indexOf(type.id) > -1} />
              <ListItemText primary={type.title} />
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={updateTrialTypes}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTrialTypePopUp;
